import createCache from "@emotion/cache";
import { Box, Button, createTheme } from "@mui/material";
import React, { useState } from "react";
import { useQueryClient } from "react-query";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { SupplierBranchUserFilter } from "../../models/supplierUserBarnch.model";
import ChipCmp from "../chip/chipCmp";
import DropdownCmp2 from "../dropdown/DropdownCmp2";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
const activeStateOptions = [
  { title: "فعال", id: 1, enumData: "true" },
  { title: "غیر فعال", id: 2, enumData: "false" },
];
interface Props {
  setFilterObject: (filterObj: SupplierBranchUserFilter) => void;
  setCurrentPaginationInfo: (page: any) => void;
}
const SupplierBranchUserFilters = ({
  setFilterObject,
  setCurrentPaginationInfo,
}: Props) => {
  const [formData, setFormData] = useState<SupplierBranchUserFilter>();
  const [activeStatusValue, setActiveStatusValue] = useState<any>();
  const queryClient = useQueryClient();
  const [activeStatusToChip, setactiveStatusToChip] = useState("");

  const handleSelectedActiveStatusDrop = (e: any, value: any) => {
    setActiveStatusValue(e.target.value);
    let obj = activeStateOptions.filter(
      (item) => item.enumData === e.target.value
    );
    setactiveStatusToChip(obj[0].title);
  };
  const handleFormSubmit = () => {
    let tableFilter = queryClient.getQueryData<SupplierBranchUserFilter>(
      "SupplierBranchUserFilter"
    );
    tableFilter = {
      ...tableFilter,
      isActive:
        activeStatusValue === "true"
          ? true
          : activeStatusValue === "false"
          ? false
          : undefined,
    };
    setCurrentPaginationInfo({
      pageNumber: 1,
      pageSize: 10,
    });
    setFilterObject(tableFilter!);
  };

  const setChildfullName = () => {
    let tableFilter = queryClient.getQueryData<SupplierBranchUserFilter>(
      "SupplierBranchUserFilter"
    );
    tableFilter = { ...tableFilter!, fullName: undefined };
    setFormData({ ...formData, fullName: "" });
    queryClient.setQueryData<SupplierBranchUserFilter>(
      "SupplierBranchUserFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildnationalCode = () => {
    let tableFilter = queryClient.getQueryData<SupplierBranchUserFilter>(
      "SupplierBranchUserFilter"
    );
    tableFilter = { ...tableFilter!, nationalCode: undefined };
    setFormData({ ...formData, nationalCode: "" });
    queryClient.setQueryData<SupplierBranchUserFilter>(
      "SupplierBranchUserFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildmobileNumber = () => {
    let tableFilter = queryClient.getQueryData<SupplierBranchUserFilter>(
      "SupplierBranchUserFilter"
    );
    tableFilter = { ...tableFilter!, mobileNumber: undefined };
    setFormData({ ...formData, mobileNumber: "" });
    queryClient.setQueryData<SupplierBranchUserFilter>(
      "SupplierBranchUserFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const setChildisActive = () => {
    let tableFilter = queryClient.getQueryData<SupplierBranchUserFilter>(
      "SupplierBranchUserFilter"
    );
    tableFilter = { ...tableFilter!, isActive: undefined };
    setFormData({ ...formData, isActive: undefined });
    setactiveStatusToChip("");
    setActiveStatusValue(undefined);
    queryClient.setQueryData<SupplierBranchUserFilter>(
      "SupplierBranchUserFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const handleChangeForm = (event: any) => {
    setFormData({
      ...formData!,
      [event.target.id]: event.target.value,
    });
    queryClient.setQueryData<SupplierBranchUserFilter>(
      "SupplierBranchUserFilter",
      {
        ...formData!,
        [event.target.id]: event.target.value,
      }
    );
  };

  const deleteChip = () => {
    let tableFilter = queryClient.getQueryData<SupplierBranchUserFilter>(
      "SupplierBranchUserFilter"
    );
    tableFilter = {
      fullName: "",
      nationalCode: "",
      mobileNumber: "",
      isActive: undefined,
    };
    setFormData({
      ...formData,
      fullName: "",
      nationalCode: "",
      mobileNumber: "",
      isActive: undefined,
    });
    setactiveStatusToChip("");
    setActiveStatusValue(undefined);
    queryClient.setQueryData<SupplierBranchUserFilter>(
      "SupplierBranchUserFilter",
      tableFilter
    );
    setFilterObject({});
  };
  return (
    <div>
      <Box>
        <div className="row">
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"نام و نام خانوادگی"}
              label={"نام و نام خانوادگی"}
              required={false}
              value={formData?.fullName}
              onChange={(e: any) => handleChangeForm(e)}
              name="fullName"
              id="fullName"
            />
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"کد ملی"}
              label={"کد ملی"}
              required={false}
              value={formData?.nationalCode}
              onChange={(e: any) => handleChangeForm(e)}
              name="nationalCode"
              id="nationalCode"
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
              inputProps={{ maxLength: 10 }}
            />
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"شماره موبایل"}
              label={"شماره موبایل"}
              required={false}
              value={formData?.mobileNumber}
              onChange={(e: any) => handleChangeForm(e)}
              name="mobileNumber"
              id="mobileNumber"
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
              inputProps={{ maxLength: 11 }}
            />
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container"
            style={{ marginTop: "1vh" }}
          >
            <DropdownCmp2
              style={{
                paddingRight: "0 !important",
              }}
              onChange={handleSelectedActiveStatusDrop}
              value={activeStatusValue}
              label={"وضعیت"}
              options={activeStateOptions}
              name="isActive"
              id="isActive"
              darkTheme={true}
              // defaultValue={dafaultDropdownValue}
            />
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
            style={{ marginTop: "1vh" }}
          >
            <Button
              fullWidth
              variant="contained"
              // type="submit"
              className="btnForm SuccessDefault  "
              onClick={handleFormSubmit}
            >
              اعمال فیلتر
            </Button>
          </div>
        </div>
        {(formData?.fullName ||
          formData?.mobileNumber ||
          formData?.nationalCode ||
          activeStatusValue) && (
          <div
            style={{ display: "flex", alignItems: "center" }}
            className="row tableCMP"
          >
            <Button
              onClick={deleteChip}
              style={{
                justifyContent: "right",
                minWidth: "25px",
                marginRight: "-1vh",
                marginTop: "1vh",
              }}
            >
              <img
                style={{ height: "24px", width: "24px" }}
                src="images/RemoveAllFilters.svg"
                alt=""
              />
            </Button>
            <ChipCmp
              item={formData?.fullName}
              enamValue={formData?.fullName}
              index={formData?.fullName?.length}
              setChildValue={setChildfullName}
            />
            <ChipCmp
              item={formData?.nationalCode}
              enamValue={formData?.nationalCode}
              index={formData?.nationalCode?.length}
              setChildValue={setChildnationalCode}
            />
            <ChipCmp
              item={formData?.mobileNumber}
              enamValue={formData?.mobileNumber}
              index={formData?.mobileNumber?.length}
              setChildValue={setChildmobileNumber}
            />
            <ChipCmp
              item={activeStatusToChip}
              enamValue={activeStatusToChip}
              setChildValue={setChildisActive}
            />
          </div>
        )}
      </Box>
    </div>
  );
};

export default SupplierBranchUserFilters;
